module.exports = global["$"] = require("-!C:\\bamboo-agent-2-home\\xml-data\\build-dir\\TNEW6-RV483-JOB1\\Source\\Source\\ExpressWeb\\ExpressWeb\\ui\\public\\node_modules\\imports-loader\\index.js?jQuery=jquery,$=jquery,this=>window!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/imports-loader?jQuery=jquery,$=jquery,this=>window!./node_modules/jquery/dist/jquery.js-exposed
// module id = ./node_modules/expose-loader/index.js?$!./node_modules/imports-loader/index.js?jQuery=jquery,$=jquery,this=>window!./node_modules/jquery/dist/jquery.js-exposed
// module chunks = tnew-vendor